import { Directive, TemplateRef } from '@angular/core';

@Directive({ standalone: false, selector: '[appQuerySwitchGroup]' })
export class QuerySwitchGroupDirective
{
  constructor(public template: TemplateRef<any>) { }
}
